var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThanks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 103,
    viewBox: "0 0 102 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9999 102C79.1665 102 102 79.1665 102 51C102 22.8335 79.1665 0 50.9999 0C22.8335 0 0 22.8335 0 51C0 79.1665 22.8335 102 50.9999 102Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_741_2536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.9839 34.5481C72.787 34.5481 69.9143 33.4569 68.9567 33.0933C63.9295 30.7896 55.6705 24 51.122 24C46.5737 24 38.3147 30.6683 33.2875 33.0933C32.4496 33.4569 29.4571 34.5481 28.2603 34.5481C26.3451 34.6694 24.9087 36.3668 25.1482 38.1854C25.6269 42.6714 26.8239 50.6733 29.936 60.9791C34.0056 73.7095 45.257 81.3478 49.566 83.8938C50.6433 84.5001 51.8403 84.5001 52.9175 83.8938C57.2266 81.3478 68.4779 73.7095 72.3081 60.9791C75.4202 50.6733 76.6172 42.6714 77.096 38.1854C77.3354 36.3668 75.8991 34.6694 73.9839 34.5481Z",
    fill: "url(#paint0_linear_741_2536)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4281 39.0356C71.9494 42.6729 70.9918 48.8563 68.8373 56.6158C68.5979 57.5857 68.2388 58.6769 67.8797 59.6469C64.648 70.195 55.5511 76.8633 51.1224 79.5307C50.6437 79.2881 50.1648 78.9244 49.686 78.5607C45.0179 75.4084 37.3574 69.1038 34.4847 59.6469C31.7318 50.5536 30.5348 43.1579 29.9363 39.0356C32.0908 38.5507 34.7241 37.5806 35.2028 37.3382C37.2377 36.3683 39.5119 35.0346 41.9059 33.4584C44.5391 31.7611 49.4467 28.73 51.1224 28.73C52.7981 28.73 57.7057 31.8823 60.3389 33.4584C62.7329 34.9134 65.0071 36.3683 67.0418 37.3382C67.6403 37.4594 70.2737 38.5507 72.4281 39.0356Z",
    fill: "url(#paint1_linear_741_2536)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8341 56.4889C68.5947 57.4588 68.2357 58.5499 67.8766 59.52C64.6448 70.068 55.548 76.7364 51.1192 79.4037C50.6404 79.1612 50.1617 78.7976 49.6828 78.4338L40.8254 53.2152L45.0148 52.4879L50.2813 56.3677L61.6524 48.1231L65.2433 46.9106C65.2433 47.0319 66.7994 51.2754 68.8341 56.4889Z",
    fill: "url(#paint2_linear_741_2536)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4896 61.5888L41.3079 54.3142C40.829 53.8293 40.829 52.8592 41.3079 52.3744L44.1806 49.4645C44.6593 48.9795 45.6168 48.9795 46.0957 49.4645L49.4472 52.8592C49.9259 53.3443 50.6441 53.3443 51.0031 52.8592L59.9803 43.766C60.4592 43.2811 61.4166 43.2811 61.8955 43.766L64.7681 46.6759C65.247 47.1609 65.247 48.1308 64.7681 48.6158L52.0804 61.5888C51.0031 62.5587 49.4472 62.5587 48.4896 61.5888Z",
    fill: "url(#paint3_linear_741_2536)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_741_2536",
    x: 13.6444,
    y: 19.6959,
    width: 74.9553,
    height: 83.3039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.17352
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.73882
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_741_2536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_741_2536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_741_2536",
    x1: 48.2787,
    y1: 42.6955,
    x2: 65.4266,
    y2: 66.4468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_741_2536",
    x1: 66.623,
    y1: 67.8066,
    x2: 40.8186,
    y2: 35.3657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_741_2536",
    x1: 50.9938,
    y1: 52.1362,
    x2: 58.7205,
    y2: 64.4257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#657EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_741_2536",
    x1: 57.569,
    y1: 55.2466,
    x2: 50.2906,
    y2: 47.4453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "#C2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanks);
export default __webpack_public_path__ + "static/media/thanks.8055bbdc190b535734ecca7ee3221c77.svg";
export { ForwardRef as ReactComponent };